import { DocumentEntity } from '@domain';

/** Documentos de um mesmo mês na visão "por mês" da ordem de serviço. */
export interface DocumentMonthGroup {
    /** `yyyy-m`, estável entre os refreshes do polling (track do @for). */
    key: string;
    /** Uma data do mês, só para o DatePipe formatar o cabeçalho. */
    date: Date;
    documents: DocumentEntity[];
}

/** Data exibida no card, em ms: última edição de conteúdo, com fallback na criação. */
export function documentDisplayTime(document: DocumentEntity): number {
    const value = document?.contentUpdatedAt ?? document?.createdAt;
    const time = value ? new Date(value).getTime() : NaN;
    return Number.isNaN(time) ? 0 : time;
}

/**
 * Agrupa os documentos pelo mês da data exibida no card, do mais recente para o
 * mais antigo. Ordena por essa data antes de agrupar: a lista da API vem pela
 * criação, e um documento antigo editado hoje tem que subir para o mês atual em
 * vez de abrir um segundo grupo do mesmo mês lá embaixo.
 */
export function groupDocumentsByMonth(documents: DocumentEntity[]): DocumentMonthGroup[] {
    const sorted = [...(documents ?? [])].sort(
        (a, b) => documentDisplayTime(b) - documentDisplayTime(a)
    );

    const groups: DocumentMonthGroup[] = [];
    for (const document of sorted) {
        const date = new Date(documentDisplayTime(document));
        const key = `${date.getFullYear()}-${date.getMonth()}`;
        let group = groups[groups.length - 1];
        if (!group || group.key !== key) {
            group = { key, date, documents: [] };
            groups.push(group);
        }
        group.documents.push(document);
    }
    return groups;
}
